import { render, staticRenderFns } from "./List.vue?vue&type=template&id=264bddce&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264bddce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitrix/ext_www/igr.ru/local/templates/main/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('264bddce')) {
      api.createRecord('264bddce', component.options)
    } else {
      api.reload('264bddce', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=264bddce&scoped=true", function () {
      api.rerender('264bddce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/List.vue"
export default component.exports